// extracted by mini-css-extract-plugin
export default {"DatePicker":"addPatient_DatePicker__svqqY","input":"addPatient_input__+YmY3","dropDown":"addPatient_dropDown__hIPI6","saveBtn":"addPatient_saveBtn__RJIIl"};